$(function () {
    let form = $('#login-form')
    let emailInput = $('#email')
    let passwordInput = $('#password')
    let rememberMeInput = $('#remember_me')
    let submitBtn = $('#js-btn-submit')

    $('#email,#password').on('keydown', function (event) {
        let commonErrorLabel = $('#error-error')
        if (commonErrorLabel.length) {
            commonErrorLabel.html('')
        }
    })

    let validator = form.validate({
        normalizer: function (value) {
            return $.trim(value)
        },
        ignore: [],
        rules: {
            email: {
                required: true,
                email: true
            },

            password: {
                required: true
            },
            // This is just dummy rule
            // It is added so that showErrors() method would show error labels under otherwise may throw error
            error: {
                required: false
            }
        },
        messages: {},
        // the default class 'error' has some styling issues so we are using custom classes
        errorClass: 'validation-error text-danger',
        errorPlacement: function (error, element) {
            error.insertAfter(element)
        },
        showErrors: function (errorMap, errorList) {
            this.defaultShowErrors()
        },
        submitHandler: function (formElement, event) {
            event.preventDefault()

            // we are using loader, so removing this code for now
            // submitBtn.html('Please Wait...')
            // submitBtn.prop('disabled', true)

            let formData = new FormData()
            formData.append('email', emailInput.val() || '')
            formData.append('password', passwordInput.val() || '')
            if (rememberMeInput.is(':checked')) {
                formData.append('remember', 1)
            }

            // let id = form.data('id')
            // let endpoint = 'country/' + id
            let url = form.data('action')

            let options = {
                // endpoint: endpoint,
                url: url,
                data: formData,
                method: 'POST',

                // contentType:false and processData:false are needed when sending formData
                contentType: false,
                processData: false,
                disableLoader: false
            }

            const client = new HttpClient(options)

            client.acceptJson()
            client.setErrorHandler(validationHandler, 422)
            client.setSuccessHandler(successHandler)

            client.send()
        }
    })

    function validationHandler (statusCode, responseJson, jqXHR, httpClient) {
        let response = responseJson
        if (response) {
            let errors = (response || {}).errors
            if (errors) {
                validator.showErrors(response.errors)
            }
        }
    }

    function successHandler (response, textStatus, jqXHR, httpClient) {
        if (response.success) {
            httpClient.dontStopLoader()
            location.href = response.data.intended || '/admin/dashboard'
        }
    }
})
